export type AddressRegion = {
  region_code?: string | null;
  region?: string | null;
  region_id?: number;
};

export type Address = {
  firstname: string;
  lastname: string;
  streetName: string;
  streetNumber: string;
  streetAdditional: string;
  telephone: string;
  id?: string;
  company?: string;
  provinceName?: string;
  districtName?: string;
  city: string;
  postcode: string;
  countryCode: string;
  countryName?: string;
  isDefaultBilling?: boolean;
  isDefaultShipping?: boolean;
  isPickupAddress?: boolean;
  pickupInformation?: Record<string, string>;
  district?: string;
  buildingNumber?: string;
  neighborhood?: string;
  premise?: string;
  landmark?: string;
  shortAddress?: string;
  regionCode?: string;
  region?: AddressRegion;
};

export type AddressStored = Address & {
  id: string;
  isSubscription: boolean;
};

export type CasAddress = {
  country_code: string;
  street: string[];
  phone: string;
  post_code: string;
  city: string;
  first_name: string;
  last_name: string;
  default_shipping: boolean;
  default_billing: boolean;
  administrative_area_level_2?: string;
  sublocality_level_2?: string;
  building_number?: string;
  district?: string;
  neighborhood?: string;
  premise?: string;
  landmark?: string;
  short_address?: string;
  region?: AddressRegion;
};

export type AddressExtensionAttributes = { subscription: boolean };

/**
 * Requests from EVO are in fact also treated as CasAddressStored.
 * This leads to inconsistency of handling response data.
 * Ideally it needs to be fixed on a higher level.
 * To see EVO address schema look for type ConsumerAddressFields in
 * packages/evo-client/src/__generated__/types.gen.ts
 */
export type CasAddressStored = Pick<
  CasAddress,
  "country_code" | "street" | "city" | "default_shipping" | "default_billing"
> & {
  id: string | number;
  street: string[];
  country_id: string;
  firstname: string | null;
  lastname: string;
  postcode: string | null;
  telephone: string | null;
  sublocality_level_2: string | null;
  administrative_area_level_2: string | null;
  extension_attributes: AddressExtensionAttributes;
  building_number: string | null;
  district: string | null;
  neighborhood: string | null;
  premise: string | null;
  landmark: string | null;
  short_address?: string | null;
  region: AddressRegion;
};
